import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { DateScrubberComponent } from '../DateScrubber'
import { DealComponent } from '../Deal'
import { FilterSliderComponent } from '../FilterSlider'
import { LayoutPage } from '../LayoutPage'
import { SpinnerComponent } from '../Spinner'

import { FetchHelper } from '../../helpers/fetch'

import { useAppContext } from '../../hooks/useAppContext'
import { useControlSearch } from '../../hooks/useControlSearch'
import { useInfiniteScroll } from '../../hooks/useInfiniteScroll'
import { useSimpleState } from '../../hooks/useSimpleState'
import { useView } from '../../hooks/useView'

import dayjs from 'dayjs'

import './index.css'

const DealsComponent = ({ value, config={}, events={} }) => {
    const navigate = useNavigate();
    const {ac} = useAppContext()

    const {_state} = useSimpleState({
        fetching: false,
        filterPriceRange: [10, 30]
    })

    const {_state: _allDates} = useSimpleState(null)

    const {_view} = useView({
        initialView: 'loading',
        views: {
            loading: renderLoading,
            main: renderMain
        }
    })

    const {_control, _results, _params, _pagination} = useControlSearch({
        perPage: 5,
        afterFetch: () => {
            _view.set('main')
            restoreScrollPosition()
        }
    })

    const {sentinelRef} = useInfiniteScroll({
        enabled: _view.active() === 'main' && _control.hasMore(),
        onIntersect: _control.loadMore
    })

    const restoreScrollPosition = () => {
        let savedY = ac._state.get('homeScrollY')

        if (typeof savedY !== 'number')
            return

        ac._state.set('homeScrollY', null)

        setTimeout(() => {
            window.scrollTo(0, savedY)
        }, 0)
    }

    useEffect(() => {
        let throttled = false

        const handleScroll = () => {
            if (throttled)
                return

            throttled = true

            setTimeout(() => {
                ac._state.set('homeScrollY', window.scrollY)
                throttled = false
            }, 200)
        }

        window.addEventListener('scroll', handleScroll)

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const handleFilterPriceChange = (value) => {
        _params.set('priceFinal', value)
    }

    const handleFilterPriceReset = () => {
        _params.set('priceFinal', null)
    }

    const handleDealClick = (item) => {
        _control.fetchClick(item)

        setTimeout(() => {
            window.open(item.url, '_blank')
        }, 500)
    }

    const handleDealClickDead = (item) => {
        _control.fetchClickDead(item)
    }

    const scrollToDate = (date) => {
        document.querySelector(`[data-date="${date}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    const handleDateSelect = (date) => {
        let el = document.querySelector(`[data-date="${date}"]`)

        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' })
            return
        }

        // not loaded into the feed yet — Get_List's date param jumps
        // straight to the page containing it instead of the client
        // guessing a page number or loadMore()-ing until it appears
        _control.goToDate(date).then(() => {
            setTimeout(() => scrollToDate(date), 0)
        })
    }

    const handleDateScrubberExpand = () => {
        if (_allDates.get())
            return

        FetchHelper({ url: '/api/v1/deals/dates' })
            .then((res) => {
                if (res.status === 200)
                    _allDates.set(res.body.data)
            })
    }

    const getLoadedDates = () => {
        return (_results.get()?.body?.data || []).map((item) => ({ date: item.date, count: item.items.length }))
    }

    const getList = () => {
        const deals = _results.get()?.body?.data

        if (!deals?.length) {
            return (
                <div className="deals-dealsSectionNoResults">
                    <h2>No Deals...</h2>
                    <p>Start saving for when more show up!</p>
                </div>
            )
        }

        return (
            deals.map((item, index) => {
                return (
                    <div className="deals-dealsSection" data-date={item.date} key={`deals-dealsSection-${item.date}-${index}`}>
                        <div className="deals-dealsSectionDate">
                            <span className="bubble bubble-green">{dayjs(item.date).format('MMMM D, YYYY')}</span>
                        </div>

                        <div className="deals-dealsSectionItems">
                            {item.items.map((itm) => {
                                return <DealComponent value={itm} key={`deal-${itm.id}`} events={{
                                    handleClick: handleDealClick,
                                    handleClickDead: handleDealClickDead
                                }} />
                            })}
                        </div>
                    </div>
                )
            })
        )
    }

    function renderLoading() {
        return (
            <div className="deals-deals">
                <SpinnerComponent />
            </div>
        )
    }

    function renderMain() {
        return (
            <div className="deals-deals">
                {/* <div className="deals-filters">
                    <FilterSliderComponent value={_state.get('filterPriceRange')} events={{
                        handleChange: handleFilterPriceChange,
                        handleClickReset: handleFilterPriceReset
                    }} />
                </div> */}
                <div className="deals-dealsCollection">
                    {getList()}
                </div>

                {_control.hasMore() ? (
                    <div className="deals-dealsLoadMore" ref={sentinelRef}>
                        {_pagination.get('loadingMore') ? <SpinnerComponent config={{ size: 'small' }} /> : null}
                    </div>
                ) : null}

                <DateScrubberComponent value={_allDates.get() || getLoadedDates()} events={{ handleSelect: handleDateSelect, handleExpand: handleDateScrubberExpand }} />
            </div>
        )
    }

    return (
        <div className="c-Deals">
            {_view.get()}
        </div>
    )
}

export { DealsComponent }
